module.exports = __webpack_public_path__ + "static/media/gray-back-arrow.1d438b14.svg";